import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoggingModuleOptions } from './models/sync-log-message';
import { SyncLogComponent } from './components/sync-log/sync-log.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  imports: [
    CommonModule,
    MatSlideToggleModule,
  ],
  declarations: [SyncLogComponent],
  exports: [SyncLogComponent]
})
export class LoggingModule {
  options: LoggingModuleOptions;
  static forRoot(options: LoggingModuleOptions): ModuleWithProviders<LoggingModule> {
    return {
      ngModule: LoggingModule,
      providers: [
        {
          provide: LoggingModuleOptions,
          useValue: options
        }
      ]
    };
  }
}
